import script from "./EmptyStateSuggestion.vue?vue&type=script&lang=js"
export * from "./EmptyStateSuggestion.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__